import { Component, Input, OnInit } from '@angular/core';
import {
  IEditableContent,
  IEditableContentItem,
} from 'src/app/interfaces/IEditableContent';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-editable-content',
  templateUrl: './editable-content.component.html',
  styleUrls: ['./editable-content.component.scss'],
})
export class EditableContentComponent implements OnInit {
  @Input() content: IEditableContent | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {}

  /**
   * Sanitize HTML content for safe rendering
   */
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.sanitize(1, html) || '';
  }

  /**
   * Get icon for content item type
   */
  getIcon(item: IEditableContentItem): string {
    switch (item.type) {
      case 'link':
        return 'link';
      case 'file':
        return 'get_app';
      default:
        return '';
    }
  }

  /**
   * Check if content has any items to display
   */
  hasContent(): boolean {
    return (
      this.content !== null &&
      this.content.items &&
      this.content.items.length > 0
    );
  }
}
